export interface ControllingTableData {
  approlStatus: string;
  customerName: string;
  id: number;
  model: string;
  retailDate: string;
  specialUsage: string;
  usabilityRebateFlag: string;
  usage: string;
  vinNo: string;
  invoicePath: string;
  licensePath: string;
  entity: string;
  failFlag: string;
  modelYear: string;
  brand: string;
}

export interface ControllingFailReasonData {
  id?: number;
  comments: string;
  replyAt: string;
}

export interface ControllingRetailHistoryData {
  id: number;
  invoiceBillingDate: string;
  invoiceDate: string;
  licenseBillingDate: string;
  licenseDate: string;
  saleFlag: string;
  specialUsage: string;
  usage: string;
  vinNo: string;
}

export interface ControllingStatusData {
  msg: string;
  code: string;
}

export const EnumControllingApprovalStatus = {
  '0000': '待提交',
  '0001': '延迟待提交',
  '1111': '已过期',
  '2222': '已提交',
  '3333': '已过期'
}

export const EnumControllingCheckStatus = {
  '0000': '无',
  '1111': '系统检查中',
  '1112': '待审核',
  '1113': '修改待审核',
  '2222': '有效',
  '3333': '无效'
}
interface SelectArray {
  code: string;
  msg: string;
}
export interface SelectData {
  typeClass: SelectArray[];
  modelYear: SelectArray[];
  powerTrain: SelectArray[];
  salesRegion: SelectArray[];
}
